const ready = require('./utilities').ready;

ready(init);

function init() {
  const currentUrl = window.location.href;
  const currentPath = window.location.pathname;
  const justSignedUp = Boolean(document.querySelector('.js-just-signed-up'));
  const isSignedIn = document.body && document.body.dataset.userSignedIn === 'true';
  const isProSubscriber = document.body && document.body.dataset.userProSubscriber === 'true';
  let userSource = parseUserSource();

  if (Object.keys(userSource).length === 0) {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = document.referrer;
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');

    userSource = {
      landingPageUrl: normalizeUrlForStorage(currentUrl),
      utmSource: utmSource || null,
      utmMedium: utmMedium || null,
      utmCampaign: utmCampaign || null,
      referrer: shouldTrackReferrer(referrer) ? referrer : null,
    };
    localStorage.setItem('userSource', JSON.stringify(userSource));
  }

  // if user visits stock picks landing page, set userSource.landingPage to stockpicks
  if (window.location.pathname === '/pro/stock-picks') {
    if (!userSource.landingPage) {
      userSource.landingPage = 'stockpicks';
      userSource.landingPageUrl = userSource.landingPageUrl || normalizeUrlForStorage(currentUrl);
      localStorage.setItem('userSource', JSON.stringify(userSource));
    }
  }

  // Keep signUpUrl fresh on every pre-signup page view, except /join.
  if (!justSignedUp && currentPath !== '/join') {
    userSource.signUpUrl = normalizeUrlForStorage(currentUrl);
    localStorage.setItem('userSource', JSON.stringify(userSource));
  }

  // Keep paidUrl fresh on every pre-payment page view, except /pro and /join.
  if (isSignedIn && !isProSubscriber && currentPath !== '/join' && !currentPath.startsWith('/pro')) {
    userSource.paidUrl = normalizeUrlForStorage(currentUrl);
    localStorage.setItem('userSource', JSON.stringify(userSource));
  }

  // if just signed up save user source
  if (justSignedUp) {
    userSource = parseUserSource();
    syncUserSource(userSource).then(() => {
      // if userSource.landingPage == 'stockpicks', redirect to stock picks landing page
      if (userSource.landingPage === 'stockpicks') {
        window.location.href = '/pro/stock-picks';
      }
    });
  } else if (isSignedIn && !isProSubscriber && userSource.paidUrl) {
    syncUserSource(userSource);
  }
}

function parseUserSource() {
  const rawUserSource = localStorage.getItem('userSource');
  if (!rawUserSource) return {};

  try {
    return JSON.parse(rawUserSource) || {};
  } catch (e) {
    return {};
  }
}

function shouldTrackReferrer(referrer) {
  return referrer &&
    !referrer.includes('https://stockcircle.com') &&
    !referrer.includes('accounts.google.com') &&
    !referrer.includes('localhost');
}

function normalizeUrlForStorage(urlString) {
  if (!urlString) return urlString;

  try {
    const url = new URL(urlString, window.location.origin);
    const isStockcircleDomain =
      url.hostname === window.location.hostname ||
      url.hostname === 'stockcircle.com' ||
      url.hostname.endsWith('.stockcircle.com');

    if (isStockcircleDomain) {
      return `${url.pathname}${url.search}${url.hash}`;
    }

    return url.toString();
  } catch (e) {
    return urlString;
  }
}

function syncUserSource(userSource) {
  return fetch('/save-user-source', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      source: userSource
    })
  });
}